import { PolymerElement, html } from '@polymer/polymer/polymer-element.js';
import '@polymer/paper-icon-button/paper-icon-button.js';
import '@polymer/iron-icons/iron-icons.js';
import '@polymer/paper-card/paper-card.js';
import '@polymer/paper-button/paper-button.js';
import '@cbar/localizemixin/LocalizeMixin.js';
import '@cbar/cbar-shared-styles/cbar-shared-styles.js';

/**
 * `cbar-paymentmethod-card` is an element that allows for the formatting of payment methods, this is a work in progress that will be updated when a more refined front end can be
 * worked out, however currently, the idea is to allow for importing of information in a grid layout and display information regarding to credit cards and debit accounts
 *
 * this is a very generic container and other than a custom event listener does not contain any javascript, however if the requirements of this element change, the documentation will be
 * changed to reflect such
 *
 * this currently contains 3 slots which describe the spot that the information slotted into it sits in ie top-left slots it in the top left of the card
 *
 *
 * @customElement
 * @polymer
 * @demo demo/index.html
 */
class CbarPaymentmethodCard extends Cbar.LocalizeMixin(PolymerElement) {
  static get template() {
    return html`
    <style include="cbar-shared-styles">
      :host {
        display: inline-block;
      }
      paper-card{
        width: 100%;
        margin-bottom: 1%;
      }
      .delete-button{
        color: red;
      }
      .card-actions{
      display: flex;
      justify-content: flex-end;
      }
      .payment-details {
        display: flex;
        flex-direction: column;
      }
      .owner-div{
      color: var(--cbar-secondary-text-color, grey);
      font-size: 12px;
      }
      .payment-details > * {
        margin-bottom: 8px;
      }
      .row{
         display: flex;
        justify-content: space-between;
        align-items: center;
      }
      h3{
        margin: 0;
        display: inline-flex;
      }
      .preferred-icon {
                height: 16px;
                width: 16px;
                padding: 0;
            }
    </style>
    <paper-card title="title">
      <div class="card-content">
        <div class="payment-details">
            <div>
              <h6>[[title]] </h6> 
                  <template is="dom-if" if="[[preferred]]">
                      <sup>
                          <iron-icon icon="star" gstyle="display: inline-block; margin-top: -4px; color: var(--cbar-accent-color, black);" class="preferred-icon"></iron-icon>
                      </sup>
                   </template>
            </div> 
            
            <section class="row">
                <div>[[details]]</div>
            <!-- In case we need more details here -->
                <div>[[extraDetails]]</div>
            </section>
            <div hidden$="[[!owner]]" class="owner-div">[[owner]]</div>
        </div>
      </div>
      <div class="card-actions" hidden$="[[noActions]]">
          <paper-button class="delete-button" on-tap="_removeCard">[[localize('Delete')]]</paper-button>
          <paper-button class="update-button" on-tap="_fireUpdate" hidden$="[[hideUpdate]]">[[localize('Update')]]</paper-button>
      </div>
    </paper-card>
`;
  }

  static get is() { return 'cbar-paymentmethod-card'; }
  static get properties() {
    return {
      title: {
        type: String,
        value: ''
      },
      details: {
        type: String,
        value: ''
      },
      extraDetails: {
        type: String,
        value: ''
      },
      owner: {
        type: String,
        value: ''
      },
      preferred: {
        type: Boolean,
        value: false
      },
      noActions: {
        type: Boolean,
        value: false
      },
      hideUpdate: {
        type: Boolean,
        value: false
      }
    };
  }

  ready(){
    super.ready();
    // we need to make sure that this gets fired, otherwise when adding a new one after initial dom render
    // it will not display correctly
    this.updateButton.innerText = this.localize('Update');
    this.deleteButton.innerText = this.localize('Delete');
  }

  // get the update button
  get updateButton(){
    return this.root.querySelector('.update-button');
  }

  // get the delete button
  get deleteButton(){
    return this.root.querySelector('.delete-button');
  }

  /**
   * Allows for a custom event to trigger the change of the element, this gets called when the update button is clicked.
   * @protected
   */
  _fireUpdate() {
    this.dispatchEvent(new CustomEvent("update-clicked" , {
      bubbles: true,
      composed : true
    }));
  }

  _removeCard(){
    this.dispatchEvent(new CustomEvent('delete-clicked', {
      bubbles: true,
      composed: true
    }));
  }
}

window.customElements.define(CbarPaymentmethodCard.is, CbarPaymentmethodCard);
